const api = require("./api");

export default function confirmPhone(code) {
	return api(
		{
			url:     `/auth/contacts_validation/${localStorage.getItem('login')}/${code}`,
			method:  "get"
		}
	);
}
